import * as tslib_1 from "tslib";
import { PlatformEndpointService } from '../../communicator/endpoint/endpoint.service';
import { PlatformCommunicatorAuthService, } from '../../communicator/platform-communicator/platform-communicator.auth.service';
import { LoadingService } from '../../loading/loading.service';
import { ParametersService } from '../../parameters/parameters.service';
import * as i0 from "@angular/core";
import * as i1 from "../../parameters/parameters.service";
import * as i2 from "../../communicator/endpoint/endpoint.service";
import * as i3 from "../../communicator/platform-communicator/platform-communicator.auth.service";
import * as i4 from "../../loading/loading.service";
var CryptoVaultService = /** @class */ (function () {
    function CryptoVaultService(parametersService, endpointService, authService, loadingService) {
        this.parametersService = parametersService;
        this.endpointService = endpointService;
        this.authService = authService;
        this.loadingService = loadingService;
    }
    CryptoVaultService.prototype.keyExchange = function (transactionId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var token, headers;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.warn('Entró en negociación de llaves por keyCipherExchange ------');
                        this.loadingService.show();
                        token = this.authService.getSSOInformation().accessToken;
                        headers = {
                            'Content-Type': 'application/json',
                            'Authorization': "Bearer " + token,
                        };
                        return [4 /*yield*/, CV_JS.keyExchange(transactionId, this.parametersService.getParameter('criptovault').time_expiration, this.parametersService.getParameter('criptovault').time_grace, this.endpointService.URLS.CRYPTO_KEY_SERVER, this.endpointService.URLS.CRYPTO_KEY_CLIENT, headers, {})];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CryptoVaultService.prototype.encrypt = function (message) {
        return new Promise(function (resolve, reject) {
            CV_JS.encrypt(message)
                .then(function (data) {
                resolve(data);
            })
                .catch(function (error) {
                reject(error);
            });
        });
    };
    CryptoVaultService.prototype.decrypt = function (message) {
        return CV_JS.decrypt(message);
    };
    CryptoVaultService.prototype.refreshKeyCrypto = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loadingService.show();
                        return [4 /*yield*/, CV_JS.refreshKey().then(function () { return _this.loadingService.hide(); })
                                .catch(function () { return _this.loadingService.hide(); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CryptoVaultService.prototype.clear = function () {
        return CV_JS.clear();
    };
    CryptoVaultService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CryptoVaultService_Factory() { return new CryptoVaultService(i0.ɵɵinject(i1.ParametersService), i0.ɵɵinject(i2.PlatformEndpointService), i0.ɵɵinject(i3.PlatformCommunicatorAuthService), i0.ɵɵinject(i4.LoadingService)); }, token: CryptoVaultService, providedIn: "root" });
    return CryptoVaultService;
}());
export { CryptoVaultService };
